import Vue from 'vue';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

Vue.component('form-number', {
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        ...utils.forms.computed,
    },
    methods: {
        ...methods,
        sync(prop, value) {
            const v = parseFloat(value);
            if (!(prop in this.cmodel))
                Vue.set(this.cmodel, prop, v);
            else
                this.cmodel[prop] = v;
        }
    },
    props: {
        name: '',
        schemakey: '',
        root: null,
        schema: null,
        cmodel: null,
        extra: null,
        readonly: false,
        child: 0,
        propertygrid: false,
    },
    render(h) {
        if (!this.Condition)
            return null;

        let desc;
        if (this.schema.description)
            desc = <i class="mdi mdi-information" title={this.schema.description} style={{ color: "silver", fontSize: "small", marginLeft: "3px" }}></i>;

        const name = <span style={{ marginLeft: (this.child * 15) + "px" }}>{this.name}</span>;

        let input;
        if (this.readonly)
            input = <v-text-field type="number" solo single-line dense hide-details style={{ width: "100%" }} value={this.cmodel[this.schemakey]} disabled="disabled"></v-text-field>;
        else
            input = <v-text-field type="number" solo single-line dense hide-details style={{ width: "100%" }} value={this.cmodel[this.schemakey]} on-input={(value) => this.sync(this.schemakey, value)}></v-text-field>;

        return (
            <tr>
                <td style={{ width: "1px" }}>
                    {name} {desc}
                </td>
                <td class={{ "property-grid": this.propertygrid }}>
                    {input}
                </td>
            </tr>
        );
    }
});